// TODO: add list of GPUs? if necessary

function isSupported() {
	const canvas = document.createElement("canvas");
	canvas.setAttribute("width", "1");
	canvas.setAttribute("height", "1");
	document.body.appendChild(canvas);

	const gl = canvas.getContext("webgl", {stencil: true, failIfMajorPerformanceCaveat: true})
		|| canvas.getContext("experimental-webgl", {stencil: true, failIfMajorPerformanceCaveat: true});
	canvas.parentNode.removeChild(canvas);

	if (!gl) return false;

	const dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
	if (dbgRenderInfo !== null) {
		const renderer = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
		if (renderer.includes("Mali-4")) {
			return false;
		}
	}

	return true;
}

function disable() { // Forces canvas
	const getContext = HTMLCanvasElement.prototype.getContext;
	HTMLCanvasElement.prototype.getContext = function (str) { // eslint-disable-line
		if (str.includes("webgl")) {
			return null;
		}

		return getContext.call(this, str);
	};
}

module.exports = {isSupported, disable};



// WEBPACK FOOTER //
// ./js/webgl.js